import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import config from "../../config";
import { hasValidAuthSession } from "../../auth/authSafety";
//-----------------------|| AUTH GUARD ||-----------------------//

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }) => {
  const location = useLocation();
  const account = useSelector((state) => state.auth);
  if (!hasValidAuthSession(account)) {
    return <Navigate to={config.basename} replace state={{ from: `${location.pathname}${location.search}${location.hash}` }} />;
  }

  return children;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default AuthGuard;
